import axios from "axios";

import { API_URL } from "../utils/Constant";
import { serializeQueryParams } from "../utils/helpers";

export const getSpecsData = async (payload, isUpdating = false, signal) => { /* eslint-disable-line import/prefer-default-export */
  try {
    const params = {
      filter: payload.filter,
      search_value: payload.search,
      product_id: payload.product_id,
      specs: payload.specs,
      page: payload.page,
      search_field: payload.search_field,
    };
    let response;
    if (isUpdating) {
      params.action = payload.action ? payload.action : "update_specs";
      response = await axios.patch(`${API_URL}/specsmanager/`, params);
    } else {
      response = await axios.get(`${API_URL}/specsmanager/`, { params, signal, paramsSerializer: serializeQueryParams });
    }

    const { message } = response.data;
    const {
      prev_page_link: prevPageLink, next_page_link: nextPageLink, last_page_link: lastPageLink, total_page: totalPage,
    } = response.data;
    const res = {
      prevPageLink, nextPageLink, lastPageLink, totalPage,
    };

    if (message === "Success" || message === "success") {
      return { success: true, files: response.data.result, pages: res };
    }
    if (message === "Specs and status updated, reports from last 30 days updated") {
      return { success: true };
    }

    return { success: false, message: "Something went wrong." };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * globalspecs/ GET
 * Params: user_payload, company_name (from interceptor), test_display_name (optional),
 *         filter, search, page (for list pagination)
 * - Without test_display_name: result = [{ test, spec_status, products_count, standard_specs }]
 *   (standard_specs nullable; optional specs_type; countries_list: string[] or { country, selected }[];
 *    optional test_type; pagination: prev_page_link, next_page_link, last_page_link, total_page)
 * - With test_display_name: result = { test, min, max, unit, multi_hits, products }
 */
export const getGlobalSpecs = async (params = {}, signal) => {
  try {
    const response = await axios.get(`${API_URL}/globalspecs/`, {
      params,
      paramsSerializer: serializeQueryParams,
      signal,
    });
    const { message } = response.data;
    const {
      prev_page_link: prevPageLink,
      next_page_link: nextPageLink,
      last_page_link: lastPageLink,
      total_page: totalPage,
    } = response.data;
    return {
      success: message === "Success",
      result: response.data.result,
      pages: {
        nextPageLink: nextPageLink || "",
        prevPageLink: prevPageLink || "",
        lastPageLink: lastPageLink || "",
        totalPage,
      },
      message,
    };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

/**
 * globalspecs/ POST
 * Payload: test_display_name, test_spec: { min, max, unit, countries_lst? },
 *          update_operation: "standard_only" | "all_selected", product_list: [{ product_id, specs_type }].
 * user_payload / company_name are added by the axios interceptor.
 */
export const postGlobalSpecs = async (payload) => {
  try {
    const requestPayload = {
      test_display_name: payload.test_display_name,
      test_spec: payload.test_spec,
      update_operation: payload.update_operation,
      product_list: payload.product_list,
    };

    const response = await axios.post(`${API_URL}/globalspecs/`, requestPayload);
    const { message } = response.data;
    return { success: message === "Success" };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
    };
  }
};

/**
 * getallproducts/ GET
 * Params: user_payload, company_name
 * Response: result = [{ product_id, product_identifier: { item, description } }]
 */
export const getAllProducts = async (signal) => {
  try {
    const response = await axios.get(`${API_URL}/getallproducts/`, { signal });
    const { message } = response.data;
    const products = response.data.result;
    return { success: message === "Success", products, message };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
    };
  }
};

/**
 * getspecsunits/ GET
 * Params: user_payload, company_name
 * Response: result = ["CFU/g", "CFU", "mg/kg", "ppb", "ppm", "%", "g", "ml"]
 */
export const getSpecsUnits = async (signal) => {
  try {
    const response = await axios.get(`${API_URL}/getspecsunits/`, { signal });
    const { message } = response.data;
    return { success: message === "Success", result: response.data.result, message };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
    };
  }
};
